"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSupportedCurrencies = exports.getCurrencyPlaceholders = exports.getCurrencySeparators = exports.parseCurrency = exports.formatCurrencyToParts = exports.formatCurrency = exports.CurrencyFormatter = void 0;
const FormatterUtils_1 = require("../FormatterUtils");
const CurrencyUtils_1 = require("./CurrencyUtils");
const NumberUtils_1 = require("./NumberUtils");
class CurrencyFormatter {
    constructor(currencyOptions) {
        this.formatter = (0, CurrencyUtils_1.getCurrencyFormatter)(currencyOptions);
    }
    formatCurrency(value) {
        return (0, NumberUtils_1.formatNumberOrCurrency)(value, this.formatter);
    }
    formatCurrencyToParts(value) {
        return this.formatter.formatToParts(value);
    }
    parseCurrency(value) {
        var _a, _b, _c, _d;
        const control = this.formatCurrencyToParts(-1e9 + 0.1);
        const group = (_a = control.find((prop) => prop.type === "group")) === null || _a === void 0 ? void 0 : _a.value;
        const decimal = (_b = control.find((prop) => prop.type === "decimal")) === null || _b === void 0 ? void 0 : _b.value;
        const currency = (_c = control.find((prop) => prop.type === "currency")) === null || _c === void 0 ? void 0 : _c.value;
        const minusSign = (_d = control.find((prop) => prop.type === "minusSign")) === null || _d === void 0 ? void 0 : _d.value;
        const literals = control
            .filter((prop) => prop.type === "literal")
            .map((literal) => literal.value);
        const sign = (minusSign && value.includes(minusSign)) ||
            value.includes("-") ||
            value.includes("(")
            ? -1
            : 1;
        const converted = literals
            .reduce((val, literal) => val.replace(new RegExp((0, FormatterUtils_1.escapeRegEx)(literal), "g"), ""), value)
            .replace(new RegExp((0, FormatterUtils_1.escapeRegEx)(group), "g"), "")
            .replace(decimal, ".")
            .replace(currency, "")
            .replace(minusSign, "")
            .replace("-", "")
            .replace(/\s/g, "")
            .trim();
        return parseFloat(converted) * sign;
    }
    getCurrencySeparators() {
        var _a;
        const parts = this.formatCurrencyToParts(1e9 + 0.11);
        return {
            decimal: (_a = parts.find(({ type }) => type === "decimal")) === null || _a === void 0 ? void 0 : _a.value,
            group: parts.find(({ type }) => type === "group").value,
        };
    }
    getCurrencyPlaceholders() {
        const formattedPositiveNumber = this.formatCurrency(1234560.0);
        const formattedNegativeNumber = this.formatCurrency(-1234560.0);
        const positive = formattedPositiveNumber.replace(/[1-9]/g, "#");
        const negative = formattedNegativeNumber.replace(/[1-9]/g, "#");
        return `${positive};${negative}`;
    }
    getSupportedCurrencies() {
        return (0, CurrencyUtils_1.supportedCurrencies)();
    }
}
exports.CurrencyFormatter = CurrencyFormatter;
function formatCurrency(value, currencyOptions) {
    const formatter = new CurrencyFormatter(currencyOptions);
    return formatter.formatCurrency(value);
}
exports.formatCurrency = formatCurrency;
function formatCurrencyToParts(value, currencyOptions) {
    const formatter = new CurrencyFormatter(currencyOptions);
    return formatter.formatCurrencyToParts(value);
}
exports.formatCurrencyToParts = formatCurrencyToParts;
function parseCurrency(value, currencyOptions) {
    const formatter = new CurrencyFormatter(currencyOptions);
    return formatter.parseCurrency(value);
}
exports.parseCurrency = parseCurrency;
function getCurrencySeparators(currencyOptions) {
    const formatter = new CurrencyFormatter(currencyOptions);
    return formatter.getCurrencySeparators();
}
exports.getCurrencySeparators = getCurrencySeparators;
function getCurrencyPlaceholders(currencyOptions) {
    const formatter = new CurrencyFormatter(currencyOptions);
    return formatter.getCurrencyPlaceholders();
}
exports.getCurrencyPlaceholders = getCurrencyPlaceholders;
function getSupportedCurrencies(currencyOptions) {
    const formatter = new CurrencyFormatter(currencyOptions);
    return formatter.getSupportedCurrencies();
}
exports.getSupportedCurrencies = getSupportedCurrencies;
//# sourceMappingURL=CurrencyFormatter.js.map